import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../config";
import { generateCorrelationId } from "../utils/helpers";
import formatDashboardData from "../models/DashboardData";

export const dashboardApi = createApi({
    reducerPath: "dashboardApi",
    baseQuery: fetchBaseQuery({
        baseUrl: config.REACT_APP_API_URL,
        credentials: "include",
        prepareHeaders: (headers) => {
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");

            const apiKey = process.env.REACT_APP_API_KEY;
            if (apiKey) {
                headers.set("apikey", apiKey);
            }

            const correlationId = generateCorrelationId();
            if (correlationId) {
                headers.set("x-unum-correlation-id", correlationId);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getDisabilityComparisons: builder.query({
            query: ({
                organizationIds,
                policyDivisions,
                claimStatuses,
                coverageTypes,
                sicCodes,
                pflClaimExclude,
                startYear,
                startQuarter,
                endYear,
                endQuarter,
                compareTypes,
                // TODO: uncomment once /disability-comparisons supports the `groupBy` query param
                // groupBy,
                reportingGroups,
            }) => ({
                url: `/dashboards/${process.env.REACT_APP_API_VERSION}/disability-comparisons${config.REACT_APP_ENV_NAME}`,
                method: "GET",
                params: {
                    organizationIds,
                    policyDivisions,
                    claimStatuses,
                    coverageTypes,
                    sicCodes,
                    pflClaimExclude,
                    startYear,
                    startQuarter,
                    endYear,
                    endQuarter,
                    compareTypes,
                    // groupBy, // TODO: uncomment once API supports it
                    reportingGroups,
                },
            }),
            transformResponse: (response) => {
                const formattedCharts = formatDashboardData(response); // ✅ USE FUNCTION
                return {
                    ...response,
                    formattedCharts,
                };
            },
        }),
    }),
});

export const { useLazyGetDisabilityComparisonsQuery } = dashboardApi;
